import {
  ModalBody,
  ModalContent,
  Modal,
  ModalOverlay,
  Text,
  ModalCloseButton,
} from "@chakra-ui/react";
import { SecondaryButton } from "components/base/atoms/HJSButton";
import MessageScreen from "components/base/molecules/MessageScreen";
import { useHistory } from "react-router-dom";

interface IModalMessageComponentProps {
  open: boolean;
  handleClose: () => void;
}
type TModalComponent = (props: IModalMessageComponentProps) => JSX.Element;
const MessageDialog: TModalComponent = ({
  open,
  handleClose,
}: IModalMessageComponentProps) => {
  const history = useHistory();
  return (
    <Modal
      allowPinchZoom
      blockScrollOnMount={false}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
      isOpen={open}
      onClose={handleClose}
    >
      <ModalOverlay backdropFilter="blur(10px) hue-rotate(90deg)" />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody overflowY="auto" maxH="calc(100vh - 10px)">
          <MessageScreen
            // eslint-disable-next-line no-template-curly-in-string
            message={
              <>
                <Text className="font-normal">
                  You earned $20 for your time!{" "}
                  <span className="font-bold text-red-500">
                    The last step before we can process your check is for you to
                    visit the job search page:
                  </span>
                </Text>

                <SecondaryButton
                  className="my-4 mt-8"
                  onClick={() => history.push("/jobs/search")}
                >
                  Apply for Jobs
                </SecondaryButton>
                <Text className="font-normal">
                  We’ll process your check as soon as you visit the job search
                  page and you should get your check within 14 business days.
                </Text>

                <Text className="font-normal my-4 mt-8">
                  If you continue to use Job Search page and take additional
                  surveys to share how your job search is going, you can earn an
                  additional $60 !
                </Text>
              </>
            }
            alt="Eligible"
            src="https://assets8.lottiefiles.com/packages/lf20_xrbvwh6y.json"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default MessageDialog;
